var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 310 255.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #329e51;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m310,8v213H123.84c-2.8,14.79-23.91,32.04-27.15,33.81-3.3,1.82-2.69-.81-2.69-.81,7.02-10.13,5.52-26.34,4.53-33H8V8h302Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "82 0 82 7.45 7.45 7.45 7.45 82 0 82 0 0 82 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowDialog);
export default __webpack_public_path__ + "static/media/window_dialog.c47721fbe37599dae7a72c2b18a6ba5d.svg";
export { ForwardRef as ReactComponent };